import firebase from "@firebase/app";
import "@firebase/firestore";
import "@firebase/auth";
import "@firebase/storage";

var config = ''
if (process.env.NODE_ENV !== 'production') {
  //testing and development
  console.log('loaded ' + process.env.NODE_ENV)
  config = {
    apiKey: "AIzaSyBeJMlzPstaLLmc6FDqPRjvWWDUhrFZUts",
    authDomain: "ccbcms1.firebaseapp.com",
    databaseURL: "https://ccbcms1.firebaseio.com",
    projectId: "ccbcms1",
    storageBucket: "ccbcms1.appspot.com",
    messagingSenderId: "891979734736",
    appId: "1:891979734736:web:cb26ecb453ed8cd2"
  };

} else {
  //production
  console.log('loaded ' + process.env.NODE_ENV)
  config = {
    apiKey: "AIzaSyBeJMlzPstaLLmc6FDqPRjvWWDUhrFZUts",
    authDomain: "ccbcms1.firebaseapp.com",
    databaseURL: "https://ccbcms1.firebaseio.com",
    projectId: "ccbcms1",
    storageBucket: "ccbcms1.appspot.com",
    messagingSenderId: "891979734736",
    appId: "1:891979734736:web:cb26ecb453ed8cd2"
  };
}

const app = firebase.initializeApp(config);
const db = firebase.firestore(app);
const auth = firebase.auth();
const storr = firebase.storage();
const fb = firebase;
// const settings = {/* your settings... */ timestampsInSnapshots: true };
// db.settings(settings);

export {
  auth,
  db,
  storr,
  app,
  fb
};




// WEBPACK FOOTER //
// ./src/firebase/firebase.js